module.exports = __webpack_public_path__ + "img/Image_2__First_Canal_L_1_45_976_Linking_the_Great_Lakes.a8beaee6.jpg";